/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_MarkersInputs */



/**
* | output |
* | --- |
* | "Markers" |
*
* @param {Options_Quicktools_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_markers = /** @type {((inputs?: Options_Quicktools_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्करों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores")
	return /** @type {LocalizedString} */ ("Markers")
});